module.exports = __webpack_public_path__ + "static/img/meetingCol.933bea99.svg";